import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {AngularMultiSelectModule} from '../../angular2-multiselect-dropdown/multiselect.component';
import {DatetimeModule} from '../../datetime/datetime.module';

import {CommonComponentsModule} from '../../../common-components.module';
import {ChangeUnitModalComponent} from './change-unit-modal.component';
import {UtilsModule} from '../../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        AngularMultiSelectModule,
        DatetimeModule,
        CommonComponentsModule,
        UtilsModule
    ],
    declarations: [
        ChangeUnitModalComponent
    ],
    exports: [
        ChangeUnitModalComponent
    ],
    providers: [],
})
export class ChangeUnitModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/change-unit-modal/change-unit-modal.module.ts